import { render, staticRenderFns } from "./ModalChangeTariff.vue?vue&type=template&id=50ef9d03"
import script from "./ModalChangeTariff.vue?vue&type=script&lang=js"
export * from "./ModalChangeTariff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports